<!--
 * @Description: 发送短信 确认支付
 * @Date: 2019-09-02 09:48:51
 -->
<template>
  <div>
    <el-dialog
      :visible="true"
      width="350px"
      class="chartDia"
      :show-close="false"
      @close="close"
    >
      <div slot="title" class="slotTit">确认支付</div>
      <div style="margin-bottom:30px;">
        已下发短信验证码至您的手机：{{ user.transactorPhone | transPhone }}
      </div>
      <div class="flexBox" style="justify-content:center;">
        <el-input
          placeholder="请输入验证码"
          style="width:200px;margin-right:10px;"
          v-model="verifyCode"
        ></el-input>
        <el-button
          @click="sendSms"
          style="border:1px solid rgba(25,137,250,1);color:#1989FA"
        >
          {{ txt }}
        </el-button>
      </div>
      <div class="flexBox" style="justify-content:center;margin-top:24px;">
        <el-button
          style="background:rgba(198,203,212,1);color:#fff;margin-right:120px;"
          @click="close"
        >
          返回
        </el-button>
        <el-button type="primary" @click="confirm" :loading="btLoading">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { bfAccount, comprehensive } from '@/api/ajax';
import { btLoading } from '@/Mixin/btLoading';
export default {
  inject: ['itemData'],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  mixins: [btLoading],
  data() {
    return {
      user: {
        transactorPhone: ''
      },
      feiyongList: [
        { label: '合同签约费', key: 1 },
        { label: '实名认证费', key: 2 }
      ],
      showDetail: false,
      key: 'baofu',
      verifyCode: '',
      txt: '发送验证码',
      timer: null
    };
  },
  methods: {
    async sendSms() {
      if (this.txt == '发送验证码') {
        try {
          this.txt = 60;
          await comprehensive.sendComprehensiveOrderPayMsg({
            orderId: this.itemData.data.id
          });
          this.timer = setInterval(() => {
            if (this.txt > 0) {
              this.txt--;
            } else {
              this.txt = '发送验证码';
              clearInterval(this.timer);
            }
          }, 1000);
        } catch (error) {
          this.txt = '发送验证码';
        }
      }
    },
    close() {
      this.$parent.componentName = '';
    },

    async confirm() {
      await this.SET_BTLOADING(true);
      try {
        await comprehensive.submitComprehensivePayOrder({
          orderId: this.itemData.data.id,
          verifyCode: this.verifyCode
        });
        this.$parent.$parent.componentName = '';
        this.$parent.$parent.getPageList(1);
        this.SET_BTLOADING(false);
      } catch (error) {
        this.SET_BTLOADING(false);
      }
    }
  },
  async created() {
    let {
      data: { data }
    } = await bfAccount();
    this.user = data;
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style lang="scss" scoped>
.flexBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 45px;
}
.colorBf {
  color: #bfbfbf;
}
.hint {
  color: #bfbfbf;
  font-size: 12px;
  margin-bottom: 16px;
}
.accountType {
  width: 138px;
}
.chargeBtn {
  width: 92px;
  height: 36px;
  background: rgba(235, 142, 14, 1);
  border-radius: 4px;
  color: #fff;
  font-size: 16px;
  line-height: 36px;
  padding: 0;
}
</style>
